module.exports = __webpack_public_path__ + "static/media/je.ac2ed887.svg";